function isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
export function isPaletteTokens(value) {
    return isRecord(value)
        && Object.values(value).every((token) => typeof token === "string" || typeof token === "number");
}
export function isThemeConfig(value) {
    if (!isRecord(value))
        return false;
    if (Object.keys(value).some((key) => key !== "palettes"))
        return false;
    if (value.palettes === undefined)
        return true;
    if (!isRecord(value.palettes))
        return false;
    return Object.values(value.palettes).every(isPaletteTokens);
}
export function createPaletteResolver(defaults) {
    const themeNames = Object.keys(defaults);
    return (overrides) => Object.fromEntries(themeNames.map((themeName) => [
        themeName,
        { ...defaults[themeName], ...(overrides?.[themeName] ?? {}) },
    ]));
}
export function resolvePalettes(defaults, overrides) {
    return createPaletteResolver(defaults)(overrides);
}
